export function formatTimestamp(timestamp: number | string) {
    if (timestamp === null) {
        return "";
    }
    if (Number(timestamp) === 0 && timestamp !== "") {
        return "00:00.000";
    }
    const smallerThanZero = Number(timestamp) / 1000 < 0;
    if (isNaN(Number(timestamp)) || timestamp === "00" || timestamp === "0" || !timestamp || smallerThanZero) {
        return String(timestamp);
    }

    const milliseconds = Math.floor(Number(timestamp) % 1000);
    const seconds = Math.floor((Number(timestamp) / 1000) % 60);
    const minutes = Math.floor((Number(timestamp) / (1000 * 60)) % 60);

    const formattedMinutes = (minutes < 10) ? "0" + minutes : minutes;
    const formattedSeconds = (seconds < 10) ? "0" + seconds : seconds;
    let formattedMilliseconds: string | number = milliseconds;
    if (milliseconds < 100) {
        formattedMilliseconds = "0" + formattedMilliseconds;
    }
    if (milliseconds < 10) {
        formattedMilliseconds = "0" + formattedMilliseconds;
    }

    return formattedMinutes + ":" + formattedSeconds + "." + formattedMilliseconds;
}
